module.exports = __webpack_public_path__ + "static/media/41.451657f9.webp";